import { COLLECTIONS } from '../constants';
import admin from './firebaseConfig';

const firestore = admin.firestore();
export const BankDataRef = restaurantId =>
  firestore
    .collection(COLLECTIONS.RESTAURANT)
    .doc(restaurantId)
    .collection(COLLECTIONS.BANK_DATA);
